import React from 'react';
import { Typography } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../utils';

import invertedMessages from './messages';

import './Header.css';

export default function Header() {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <header className='Ext-Header' data-testid='ext-usermanagement-header'>
      <div className='Ext-Header-title'>
        <Typography kind='h2' desktop='display4-d' mobile='display4-d'>
          {l('User Life-Cycle Management')}
        </Typography>
      </div>
    </header>
  );
}
